import {AfterViewInit, Component, Input, OnInit, ViewChild} from '@angular/core';
import {VirtualScrollerComponent} from 'ngx-virtual-scroller';
import {DatePipe} from '@angular/common';
import {IndiceQualidadeAr} from '../../models/indice-qualidade-ar.model';

@Component({
  selector: 'app-grafico-iqar',
  templateUrl: './grafico-iqar.component.html',
  styleUrls: ['./grafico-iqar.component.scss'],
})
export class GraficoIqarComponent implements OnInit, AfterViewInit {
  @Input() isEscuro: boolean;
  @Input() indicesQualidadeAr: Array<IndiceQualidadeAr>;
  @ViewChild(VirtualScrollerComponent)
  private virtualScroller: VirtualScrollerComponent;
  @Input() resumo: boolean = false;
  loading: boolean;
  indices = [];
  start: boolean;
  end: boolean;

  constructor() {
  }

  async ngAfterViewInit() {
    // const divisoria = this.indices.find(x => x.divisoria);
    // this.virtualScroller.scrollInto(divisoria, false, 20, 300);
    await this.virtualScroller.scrollToIndex(this.indices.length - 1);
    await setTimeout(async () => {
      for await (const indice of this.indices) {
        if (indice.divisoria) {
          continue;
        }
        indice.medicao.valor = indice.medicao.indiceQualidadeAr / 2;
      }
    }, 1000);
  }

  ngOnInit() {
    for (const indice of this.indicesQualidadeAr) {
      indice.medicao.valor = 0;
      indice.medicao.dtMedicao = indice.medicao.dtMedicao.replace(/\s/g, 'T');
      const datePipe = new DatePipe('en-US');
      let diaAtual: any = this.indicesQualidadeAr[this.indicesQualidadeAr.indexOf(indice) + 1] ?
        this.indicesQualidadeAr[this.indicesQualidadeAr.indexOf(indice) + 1].medicao.dtMedicao : 0;
      const diaAnterior = indice.medicao.dtMedicao.replace(/\s/g, 'T');
      diaAtual = diaAtual ? diaAtual.replace(/\s/g, 'T') : diaAtual;
      this.indices.push(indice);
      if (diaAtual && datePipe.transform(diaAtual, 'dd') !== datePipe.transform(diaAnterior, 'dd')) {
        this.indices.push({id: 1, divisoria: true, dtMedicao: diaAtual});
      }
    }
  }

  getChange(pageInfo: any) {
    this.start = pageInfo.startIndex === 0;
    this.end = pageInfo.endIndex === (this.indicesQualidadeAr ? this.indicesQualidadeAr.length : 0);
  }

}